// 鳴箏官網正式網域統一由此管理。
// 未來切換自訂網域時，只需修改 .env 中的 VITE_SITE_URL 即可，
// 不需更動各頁面的 canonical / og:url / Schema 程式碼。
const FALLBACK_SITE_URL = 'https://pupgak.readdy.co';

export const SITE_URL = import.meta.env.VITE_SITE_URL || FALLBACK_SITE_URL;